<template>
  <el-row>
    <Overview v-if="this.$store.state.indexTrigger == '0'&&this.$store.state.userId !== 'worker'"></Overview>
    <!-- <SearchUploadedSepeMethods
      v-if="this.$store.state.indexTrigger == '1'"
    ></SearchUploadedSepeMethods> -->
    <InputSepaMethod v-if="this.$store.state.indexTrigger == '9-1'"></InputSepaMethod>
    <SearchCompound v-if="this.$store.state.indexTrigger == '9-2'"></SearchCompound>
    <Convertor v-if="this.$store.state.indexTrigger == '9-3'"></Convertor>
    <SepaColumnManagement v-if="this.$store.state.indexTrigger == '9-4'"></SepaColumnManagement>
    <SupplierManagement v-if="this.$store.state.indexTrigger == '9-5'"></SupplierManagement>
    <RemoteManagement v-if="this.$store.state.indexTrigger == '10-1'"></RemoteManagement>
    <Setting v-if="this.$store.state.indexTrigger == '9-6'"></Setting>
    <PsdManagement v-if="this.$store.state.indexTrigger == '11'"></PsdManagement>
  </el-row>
</template>

<script>
import Overview from '../components/Overview'
// import SearchUploadedSepeMethods from '../components/sep_methods_upload/SearchUploadedSepeMethods'
import SearchCompound from '../components/separate_methods/SearchSepeMethods'
import InputSepaMethod from '../components/separate_methods/InputSepaMethods'
import SepaColumnManagement from '../components/separate_methods/SepaColumnManagement.vue'
import SupplierManagement from '../components/separate_methods/SupplierManagement.vue'
import RemoteManagement from '../components/separate_methods/RemoteManagement.vue'
import PsdManagement from '../components/separate_methods/PsdManagement.vue'
import Convertor from '../components/convertor/Convertor'
import Setting from '../components/Setting'
// import { mapActions } from 'vuex'
export default {
  name: 'Index',
  components: {
    Overview,
    // SearchUploadedSepeMethods,
    SearchCompound,
    InputSepaMethod,
    Convertor,
    Setting,
    SepaColumnManagement,
    SupplierManagement,
    RemoteManagement,
    PsdManagement
  },
  methods: {
    // ...mapActions('sepaMethods', ['updateFlowPhase']),
    // ...mapActions('sepaMethods', ['updateTLCType', 'updateColumnFillerType', 'updateFlowPhase']),
  },
  mounted() {
    this.$store.commit('updateIsLogin', false)
    let nickName = this.$cookie.get('nickname')
    let org = this.$cookie.get('org')
    this.$api.post('/datacenter/validateLogin', {}, res => {
      if (res.data.code == 200) {
        this.$store.commit('updateUserId', res.data.data.userId)
        this.$store.commit('updateNickName', nickName)
        this.$store.commit('updateOrg', org)
        this.$store.commit('updateEmail', res.data.data.email)
//         if(this.$cookie.get('userId')!=='worker'){
//  this.$api.post('/datacenter/getFlashList', {thirdCatalogueId: '',author: '',supplierId: ''}, (res) => {
//           if(res.data) {
//             if(res.data.code !== 200) {
//               this.$message({
//                 type: 'error',
//                 message: '获取子规格失败!',
//               })
//               return
//             }
//             this.$store.commit('updateFlashColumnList', res.data.data)
//           }
//         }) 
//         }
       
          } else {
            this.$router.push({ path: '/' })
          }
        })
    if(this.$cookie.get('userId')!=='worker'){
             this.$store.state.tabs=[]
              this.$store.commit('updateTabs', {
              tag: 'add',
              tab: {
              name: '0',
              title: '概览',
                      },
                  })    
          // this.$store.commit('updateTabs', {
          //     tag: 'add',
          //     tab: {
          //     name: '9-2',
          //     title: '查看分离方法',
          //             },
          //         })     
    }
    else{
      this.$store.state.tabs=[]
       this.$store.commit('updateTabs', {
          tag: 'add',
          tab: {
          name: '10-1',
          title: '远程管理',
                  },
              })
    }

  },
}
</script>

<style scoped>
.text-title {
  color: #1470d2;
}
</style>
